export default __webpack_public_path__ + "735c28acd0c8fd080f6d19ea52ec7953.svg";